export default "__VITE_ASSET__af5ba463__"